import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2.5 17.5h15v-1.667h-15V17.5zm5-3.333h10V12.5h-10v1.667zm-5-3.334h15V9.167h-15v1.666zm5-3.333h10V5.833h-10V7.5zm-5-5v1.667h15V2.5h-15z" fill="#54585D" /></svg>);